module.exports = __webpack_public_path__ + "static/img/Bachelor_010439.604d35c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010439.jpg
// module id = 165
// module chunks = 0